import {IRegulationComponents} from "../regulation-components.interface";
import {GermanyRegulationComponents} from "./components/germany.regulation-components";
import {IRealityCheckHandler} from "../../session-timer/reality-check/handlers/reality-check-handler.interface";
import {
  StandardRealityCheckHandler
} from "../../session-timer/reality-check/handlers/standard-reality-check-handler";
import {
  GermanyRealityCheckPresenter
} from "../../session-timer/reality-check/presenters/germany/germany.reality-check-presenter";
import {
  GermanySessionCoolDownHandler
} from "../../session-timer/reality-check/cooldown/germany/germany-session-cooldown.handler";
import {RegulationWithRealityCheck} from "../regulation-with-reality-check";

export class GermanyRegulation extends RegulationWithRealityCheck {


  async logoutUser(): Promise<void> {
    await this.services.specificDialogs.showConfirmLugasCoolingOffLogout({
      onAccept: async () => super.logoutUser(),
      onReject: async () => {},
    });
  }

  get components(): IRegulationComponents {
    return new GermanyRegulationComponents(this.services);
  }

  createRealityCheckHandler(): IRealityCheckHandler {
    return new StandardRealityCheckHandler(this.services,
        new GermanyRealityCheckPresenter(this.services),
        {
          requireUserConfirmation: true,
          sessionCoolDownHandler: new GermanySessionCoolDownHandler(this.services)
        });
  }
}